const TODO_MODULE_QUERY_PARAM = 'todo';

export function isToDoModule() {
    return location.search.includes(TODO_MODULE_QUERY_PARAM);
}
